/**
 * Store B checkout: intercept cart/minicart checkout, POST to backend, redirect to payment URL.
 * Only active when settings.checkout_backend_url is set.
 * Keeps cart order summary in sync with applied discount (subtotal, order discount, total, total savings).
 */
(function () {
  var backendUrl = window.STORE_CHECKOUT_BACKEND_URL;
  if (!backendUrl || typeof backendUrl !== 'string') return;
  backendUrl = backendUrl.replace(/\/$/, '');
  var PENDING_DISCOUNT_KEY = 'store_checkout_pending_discount_code';
  var CHECKOUT_TIMEOUT_MS = 70000;

  function formatMoneyAmount(amount, currencyCode) {
    if (currencyCode == null || currencyCode === '') currencyCode = 'GBP';
    var num = Number(amount);
    if (!isFinite(num)) num = 0;
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: String(currencyCode)
    }).format(num);
  }

  var subtotalSyncObserver = null;
  var subtotalSyncNode = null;

  function getActiveCurrencyCode(fallbackCode) {
    var code = '';
    try {
      var m = document.cookie.match(/store_currency=([^;]+)/);
      if (m && m[1]) code = decodeURIComponent(m[1].trim()).toUpperCase();
    } catch (e) { }
    if (!code && window.STORE_CURRENCY_CURRENT) {
      code = String(window.STORE_CURRENCY_CURRENT).toUpperCase();
    }
    if (!code && fallbackCode) {
      code = String(fallbackCode).toUpperCase();
    }
    return code;
  }

  function formatDisplayAmountHtml(amount, currencyCode) {
    var code = currencyCode || 'GBP';
    if (window.StoreCurrency && typeof window.StoreCurrency.formatDisplayAmount === 'function') {
      try {
        var rendered = window.StoreCurrency.formatDisplayAmount(amount, code);
        if (rendered && typeof rendered === 'string') {
          return /<svg[\s>]/i.test(rendered) ? rendered : escapeHtml(rendered);
        }
      } catch (e) { }
    }
    return escapeHtml(formatMoneyAmount(amount, code));
  }

  /**
   * Read a currency-converted display value from an element.
   * Handles both textContent (plain currencies) and innerHTML (SAR/AED SVG symbols).
   * Returns the parsed numeric value or NaN.
   */
  function readConvertedValue(container) {
    if (!container) return NaN;
    var priceEl = container.querySelector('[data-base-price]');
    var el = priceEl || container;
    var raw = (el.textContent || '').replace(/[^\d.,\-]/g, '').replace(/,/g, '').trim();
    if (!raw) return NaN;
    var val = parseFloat(raw);
    return isNaN(val) ? NaN : val;
  }

  function normalizeRatio(rawRatio) {
    var ratio = Number(rawRatio);
    if (!isFinite(ratio) || ratio <= 0) return null;
    if (ratio > 1 && ratio <= 100) ratio = ratio / 100;
    if (!isFinite(ratio) || ratio <= 0) return null;
    if (ratio > 1) ratio = 1;
    var pct = Math.round(ratio * 10000) / 100;
    if (!isFinite(pct) || pct <= 0) return null;
    return pct / 100;
  }

  function ratioPercentLabel(ratio) {
    if (ratio == null || !isFinite(ratio) || ratio <= 0) return '';
    var pct = Math.round(ratio * 10000) / 100;
    if (!isFinite(pct) || pct <= 0) return '';
    var pctText = String(pct);
    if (pctText.indexOf('.') !== -1) pctText = pctText.replace(/0+$/, '').replace(/\.$/, '');
    return ' (' + pctText + '%)';
  }

  function syncOrderSummary() {
    var subtotalBlock = document.querySelector('#main-cart-items .js-contents-subtotal') || document.querySelector('.cart-page-column .js-contents-subtotal');
    if (!subtotalBlock) return;
    var subtotalRow = subtotalBlock.querySelector('.js-store-checkout-subtotal-row');
    if (!subtotalRow) return;
    var subtotalCents = parseInt(subtotalRow.getAttribute('data-subtotal-cents'), 10);
    var currencyCode = subtotalRow.getAttribute('data-currency') || '';
    if (isNaN(subtotalCents) || subtotalCents < 0) return;

    var amountEl = document.querySelector('input[name="discount_amount"]');
    var titleEl = document.querySelector('input[name="discount_title"]');
    var ratioEl = document.querySelector('input[name="discount_ratio"]');
    var nativeAppliedEl = document.querySelector('.js-store-checkout-discount-applied[data-native-cart-discount="true"]');
    var discountAmount = amountEl && amountEl.value ? parseFloat(amountEl.value, 10) : 0;
    var discountTitle = titleEl && titleEl.value ? String(titleEl.value).trim() : '';
    var discountRatio = ratioEl && ratioEl.value ? parseFloat(ratioEl.value, 10) : null;

    var orderDiscountRow = subtotalBlock.querySelector('.js-store-checkout-order-discount-row');
    var orderDiscountValue = orderDiscountRow && orderDiscountRow.querySelector('.js-store-checkout-order-discount-value');
    var totalRow = subtotalBlock.querySelector('.js-store-checkout-total-row');
    var totalValue = totalRow && totalRow.querySelector('.js-store-checkout-total-value');
    var savingsRow = subtotalBlock.querySelector('.js-store-checkout-savings-row');
    var savingsValue = savingsRow && savingsRow.querySelector('.js-store-checkout-savings-value');

    if (!orderDiscountRow || !totalRow || !savingsRow) return;

    var didDisconnect = false;
    if (subtotalSyncObserver && subtotalSyncNode) {
      subtotalSyncObserver.disconnect();
      subtotalSyncObserver = null;
      didDisconnect = true;
    }
    try {
      var hasRatio = discountRatio != null && !isNaN(discountRatio) && discountRatio > 0;
      var hasAmount = discountAmount > 0 && !isNaN(discountAmount);

      if (discountTitle && (hasRatio || hasAmount)) {
        // Use a single canonical representation for the discount: a percentage ratio.
        var effectiveRatio = null;
        if (hasRatio) {
          effectiveRatio = normalizeRatio(discountRatio);
        } else if (hasAmount && subtotalCents > 0) {
          effectiveRatio = normalizeRatio(discountAmount / (subtotalCents / 100));
        }

        if (effectiveRatio == null || !isFinite(effectiveRatio) || effectiveRatio <= 0) {
          orderDiscountRow.classList.add('hidden');
          totalRow.classList.add('hidden');
          savingsRow.classList.add('hidden');
        } else {
          var percentLabel = ratioPercentLabel(effectiveRatio);
          var activeCurrency = getActiveCurrencyCode(currencyCode);
          var visibleSubtotal = readConvertedValue(subtotalBlock.querySelector('.js-store-checkout-subtotal-value'));
          var usedSubtotalFallbackCurrency = false;
          if (!isFinite(visibleSubtotal) || visibleSubtotal <= 0) {
            visibleSubtotal = subtotalCents / 100;
            usedSubtotalFallbackCurrency = true;
          }
          if (usedSubtotalFallbackCurrency && currencyCode) {
            activeCurrency = currencyCode;
          }
          var visibleDiscount = Number((visibleSubtotal * effectiveRatio).toFixed(2));
          if (!isFinite(visibleDiscount) || visibleDiscount < 0) visibleDiscount = 0;
          if (visibleDiscount > visibleSubtotal) visibleDiscount = visibleSubtotal;
          var visibleTotal = Number((Math.max(0, visibleSubtotal - visibleDiscount)).toFixed(2));

          var discountHtml = formatDisplayAmountHtml(visibleDiscount, activeCurrency);
          var totalHtml = formatDisplayAmountHtml(visibleTotal, activeCurrency);

          if (orderDiscountValue) {
            orderDiscountValue.innerHTML =
              '<span class="store-checkout-discount-tag-inline">' +
              escapeHtml(discountTitle) +
              percentLabel +
              '</span> - <span>' +
              discountHtml +
              '</span>';
          }
          orderDiscountRow.classList.remove('hidden');

          if (totalValue) {
            totalValue.innerHTML = '<span>' + totalHtml + '</span>';
          }
          totalRow.classList.remove('hidden');

          if (savingsValue) {
            savingsValue.innerHTML = '<span>' + discountHtml + '</span>';
          }
          savingsRow.classList.remove('hidden');
        }
      } else {
        orderDiscountRow.classList.add('hidden');
        totalRow.classList.add('hidden');
        savingsRow.classList.add('hidden');
      }
    } finally {
      if (didDisconnect && subtotalSyncNode) {
        subtotalSyncObserver = new MutationObserver(function () {
          syncOrderSummary();
        });
        subtotalSyncObserver.observe(subtotalSyncNode, { childList: true, subtree: true });
      }
    }
  }

  function escapeHtml(s) {
    var div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  function getNote() {
    var el = document.querySelector('textarea[name="note"], .js-cart-note textarea, cart-note textarea');
    return el ? (el.value || '').trim() : '';
  }

  function getDiscountAmount(form) {
    var container = form ? form.querySelector('.js-store-checkout-discount') : null;
    var docContainer = document.querySelector('.js-store-checkout-discount');
    var el = (container || docContainer)
      ? (container || docContainer).querySelector('input[name="discount_amount"]')
      : document.querySelector('input[name="discount_amount"]');
    if (!el || !el.value) return undefined;
    var num = parseFloat(el.value, 10);
    return isNaN(num) || num <= 0 ? undefined : num;
  }

  function getDiscountTitle(form) {
    var container = form ? form.querySelector('.js-store-checkout-discount') : null;
    var docContainer = document.querySelector('.js-store-checkout-discount');
    var el = (container || docContainer)
      ? (container || docContainer).querySelector('input[name="discount_title"]')
      : document.querySelector('input[name="discount_title"]');
    return el && el.value ? String(el.value).trim() : null;
  }

  function getDiscountRatio(form) {
    var container = form ? form.querySelector('.js-store-checkout-discount') : null;
    var docContainer = document.querySelector('.js-store-checkout-discount');
    var el = (container || docContainer)
      ? (container || docContainer).querySelector('input[name="discount_ratio"]')
      : document.querySelector('input[name="discount_ratio"]');
    if (!el || !el.value) return undefined;
    var num = parseFloat(el.value, 10);
    var ratio = normalizeRatio(num);
    return ratio == null ? undefined : ratio;
  }

  function getDiscountValueType(form) {
    var container = form ? form.querySelector('.js-store-checkout-discount') : null;
    var docContainer = document.querySelector('.js-store-checkout-discount');
    var el = (container || docContainer)
      ? (container || docContainer).querySelector('input[name="discount_value_type"]')
      : document.querySelector('input[name="discount_value_type"]');
    if (!el || !el.value) return undefined;
    var v = String(el.value).trim().toLowerCase();
    return (v === 'percentage' || v === 'fixed_amount') ? v : undefined;
  }

  function getDiscountCode(form) {
    var container = form ? form.querySelector('.js-store-checkout-discount') : null;
    var docContainer = document.querySelector('.js-store-checkout-discount');
    var el = (container || docContainer)
      ? (container || docContainer).querySelector('.js-store-checkout-discount-code')
      : document.querySelector('.js-store-checkout-discount-code');
    return el && el.value ? String(el.value).trim() : '';
  }

  function setDiscountCodeValue(code) {
    var el = document.querySelector('.js-store-checkout-discount-code');
    if (el && code) el.value = code;
  }

  function getStoredDiscountCode() {
    try {
      return (window.localStorage && localStorage.getItem(PENDING_DISCOUNT_KEY)) || '';
    } catch (e) {
      return '';
    }
  }

  function storeDiscountCode(code) {
    if (!code) return;
    try {
      if (window.localStorage) localStorage.setItem(PENDING_DISCOUNT_KEY, code);
    } catch (e) { }
  }

  function clearStoredDiscountCode() {
    try {
      if (window.localStorage) localStorage.removeItem(PENDING_DISCOUNT_KEY);
    } catch (e) { }
  }

  function findDiscountCodeFromLocation() {
    var code = '';
    try {
      var params = new URLSearchParams(window.location.search || '');
      code = params.get('discount_code') || params.get('discount') || params.get('coupon') || params.get('code') || '';
      if (!code && window.location.pathname) {
        var match = window.location.pathname.match(/\/discount\/([^\/?#]+)/i);
        if (match && match[1]) code = decodeURIComponent(match[1]);
      }
      if (!code && document.referrer) {
        var ref = new URL(document.referrer);
        var refMatch = ref.pathname.match(/\/discount\/([^\/?#]+)/i);
        if (refMatch && refMatch[1]) code = decodeURIComponent(refMatch[1]);
      }
    } catch (e) { }
    code = String(code || '').trim();
    return code.length <= 100 ? code : '';
  }

  function setCheckoutLoading(buttons, loading) {
    if (!buttons || !buttons.length) return;
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var spinner = btn.querySelector && btn.querySelector('.loading-overlay__spinner');
      var loadingOverlay = btn.querySelector && btn.querySelector('.loading-overlay');
      if (loading) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.classList.add('loading-process');
        if (spinner) {
          spinner.classList.remove('hidden');
          spinner.setAttribute('aria-hidden', 'false');
        }
        if (loadingOverlay) loadingOverlay.classList.remove('hidden');
      } else {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.classList.remove('loading-process');
        if (spinner) {
          spinner.classList.add('hidden');
          spinner.setAttribute('aria-hidden', 'true');
        }
        if (loadingOverlay) loadingOverlay.classList.add('hidden');
      }
    }
  }

  function getCheckoutButtons(form, submitter) {
    var list = [];
    if (form) {
      var inForm = form.querySelectorAll('button[name="checkout"], [data-store-checkout-cart]');
      for (var i = 0; i < inForm.length; i++) list.push(inForm[i]);
    }
    if (form && form.id === 'cart') {
      var cartBtn = document.getElementById('checkout');
      if (cartBtn && list.indexOf(cartBtn) === -1) list.push(cartBtn);
    }
    if (submitter && submitter.getAttribute && (submitter.getAttribute('name') === 'checkout' || submitter.hasAttribute('data-store-checkout-cart')) && list.indexOf(submitter) === -1) list.push(submitter);
    return list;
  }

  /** All checkout-related buttons (cart, minicart, buy-it-now). Used when clearing loading on page return. */
  function getAllCheckoutButtons() {
    var list = [];
    var byName = document.querySelectorAll('button[name="checkout"], [data-store-checkout-cart]');
    for (var i = 0; i < byName.length; i++) list.push(byName[i]);
    var byId = document.getElementById('checkout');
    if (byId && list.indexOf(byId) === -1) list.push(byId);
    var buyNow = document.querySelectorAll('[data-store-checkout-buy-now]');
    for (var j = 0; j < buyNow.length; j++) if (list.indexOf(buyNow[j]) === -1) list.push(buyNow[j]);
    return list;
  }

  function clearAllCheckoutLoading() {
    setCheckoutLoading(getAllCheckoutButtons(), false);
  }

  /**
   * Cart URL that includes bundler app discounts (same as cart page uses).
   * Without bundler-cart-call, cart.js returns undiscounted prices and Store B shows wrong total.
   */
  function getCartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var currencyCode = 'GBP';
    var subtotalRow = document.querySelector('.js-store-checkout-subtotal-row');
    if (subtotalRow && subtotalRow.getAttribute('data-currency')) {
      currencyCode = (subtotalRow.getAttribute('data-currency') || '').trim() || currencyCode;
    } else {
      try {
        var match = document.cookie.match(/store_currency=([^;]+)/);
        if (match && match[1]) {
          var decoded = decodeURIComponent(match[1].trim());
          if (decoded) currencyCode = decoded.toUpperCase();
        }
      } catch (e) { }
    }
    return root + 'cart.js?currency=' + encodeURIComponent(currencyCode) + '&bundler-cart-call&_=' + Date.now();
  }

  function cloneLineItemProperties(properties) {
    var out = {};
    if (!properties || typeof properties !== 'object') return out;
    Object.keys(properties).forEach(function (name) {
      if (!name) return;
      var value = properties[name];
      if (value == null) return;
      if (String(value).trim() === '') return;
      out[name] = value;
    });
    return out;
  }

  function buildCheckoutItemsFromCart(cart) {
    return (cart.items || []).map(function (item) {
      var qty = Math.max(1, parseInt(item.quantity, 10) || 1);
      var unitPrice = item.price;
      if (item.final_line_price != null && qty > 0) {
        var finalLine = Number(item.final_line_price);
        if (!isNaN(finalLine) && finalLine >= 0) unitPrice = Math.round(finalLine / qty);
      }
      if (unitPrice == null || (typeof unitPrice === 'number' && isNaN(unitPrice))) {
        unitPrice = item.original_price;
      }
      if (unitPrice == null || (typeof unitPrice === 'number' && isNaN(unitPrice))) {
        unitPrice = 0;
      }
      return {
        variant_id: item.variant_id || item.id,
        id: item.id,
        key: item.key,
        product_id: item.product_id,
        handle: item.handle,
        title: item.title || item.product_title || '',
        sku: item.sku,
        quantity: qty,
        price: unitPrice,
        original_price: item.original_price,
        line_price: item.line_price,
        original_line_price: item.original_line_price,
        final_line_price: item.final_line_price,
        final_price: item.final_price,
        properties: cloneLineItemProperties(item.properties),
        discounts: item.discounts || [],
        discount_allocations: item.discount_allocations || []
      };
    });
  }

  function clearCartCheckoutError() {
    var el = document.getElementById('store-checkout-cart-error');
    if (!el) return;
    el.setAttribute('hidden', 'hidden');
    el.classList.add('hidden');
    var msg = el.querySelector('.product-form__error-message');
    if (msg) msg.innerHTML = '';
  }

  function ensureCartCheckoutErrorContainer() {
    var existing = document.getElementById('store-checkout-cart-error');
    if (existing) return existing;
    var el = document.createElement('div');
    el.id = 'store-checkout-cart-error';
    el.className = 'product-form__error-message-wrapper store-checkout-cart-error mb-2 hidden';
    el.setAttribute('role', 'alert');
    el.setAttribute('hidden', 'hidden');
    el.innerHTML = '<span class="product-form__error-message"></span>';

    var cartErrors = document.getElementById('cart-errors');
    if (cartErrors) {
      cartErrors.appendChild(el);
      return el;
    }
    var form = getCartFormFromPage();
    var host = form || document.querySelector('.js-contents-subtotal') || document.querySelector('#main-cart-items') || document.body;
    if (host && host.parentNode && form) {
      host.parentNode.insertBefore(el, host);
    } else if (host) {
      host.appendChild(el);
    }
    return el;
  }

  function productUrlFromRequiredOptionsError(err) {
    if (!err || !err.handle) return '';
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'products/' + encodeURIComponent(String(err.handle));
  }

  function showCartCheckoutError(message, err) {
    var el = ensureCartCheckoutErrorContainer();
    var msg = el && el.querySelector('.product-form__error-message');
    if (!el || !msg) {
      alert(message || 'Checkout unavailable. Please try again.');
      return;
    }
    var productUrl = productUrlFromRequiredOptionsError(err);
    var html = escapeHtml(message || 'Please complete the required product options before checkout.');
    if (productUrl) {
      html += ' <a href="' + escapeHtml(productUrl) + '">Open product page</a>';
    }
    msg.innerHTML = html;
    el.removeAttribute('hidden');
    el.classList.remove('hidden');
    if (typeof el.scrollIntoView === 'function') {
      try {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (e) {
        try { el.scrollIntoView(); } catch (e2) { }
      }
    }
    el.classList.remove('animate__animated', 'animate__shakeX');
    void el.offsetWidth;
    el.classList.add('animate__animated', 'animate__shakeX');
    setTimeout(function () {
      el.classList.remove('animate__animated', 'animate__shakeX');
    }, 900);
  }

  function buildPayload(cart, note, discountAmount, discountTitle, discountRatio, discountValueType, customerId, email) {
    var items = buildCheckoutItemsFromCart(cart);
    var payload = { items: items, note: note || '' };
    if (customerId) payload.customer_id = String(customerId);
    if (email) payload.email = email;
    if (discountAmount != null) payload.discount_amount = discountAmount;
    if (discountTitle) payload.discount_title = discountTitle;
    if (discountTitle) payload.discount_code = getDiscountCode(null) || discountTitle;
    if (discountRatio != null) payload.discount_ratio = discountRatio;
    if (discountValueType) payload.discount_value_type = discountValueType;
    addPresentmentCurrency(payload);
    return payload;
  }

  function addPresentmentCurrency(payload) {
    try {
      var mode = window.STORE_CHECKOUT_CURRENCY_MODE || 'shop_currency';
      if (mode === 'display_currency') {
        var match = document.cookie.match(/store_currency=([^;]+)/);
        var code = match && match[1] ? decodeURIComponent(match[1].trim()).toUpperCase() : '';
        if (!code && window.STORE_CURRENCY_CURRENT) {
          code = String(window.STORE_CURRENCY_CURRENT).toUpperCase();
        }
        if (code && /^[A-Z]{3}$/.test(code)) payload.presentment_currency = code;
      }
    } catch (e) { }
  }

  function normalizeStoreHostname(hostname) {
    return String(hostname || '').trim().toLowerCase().replace(/^www\./, '');
  }

  function isKnownStoreUrl(parsed) {
    if (!parsed || (parsed.protocol !== 'https:' && parsed.protocol !== 'http:')) return false;
    var candidate = normalizeStoreHostname(parsed.hostname);
    if (!candidate) return false;
    var known = [normalizeStoreHostname(window.location.hostname)];
    if (window.Shopify && window.Shopify.shop) known.push(normalizeStoreHostname(window.Shopify.shop));
    try {
      if (window.shopInfo && window.shopInfo.store) {
        known.push(normalizeStoreHostname(new URL(window.shopInfo.store).hostname));
      }
    } catch (e) { }
    return known.indexOf(candidate) !== -1;
  }

  function isNativeCheckoutUrl(url) {
    if (!url) return false;
    try {
      var parsed = new URL(url, window.location.origin);
      return isKnownStoreUrl(parsed) && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout(?:\/|$)/i.test(parsed.pathname);
    } catch (e) {
      return /^\/checkout(?:\/|$|\?)/i.test(String(url));
    }
  }

  function isAgentCartUrl(url) {
    if (!url) return false;
    try {
      var parsed = new URL(url, window.location.origin);
      return isKnownStoreUrl(parsed) &&
        /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/c\/[^/]+\/?$/i.test(parsed.pathname) &&
        !!parsed.searchParams.get('key');
    } catch (e) {
      return false;
    }
  }

  function getEventAnchor(ev) {
    if (ev && typeof ev.composedPath === 'function') {
      var path = ev.composedPath();
      for (var i = 0; i < path.length; i++) {
        var node = path[i];
        if (node && node.tagName === 'A' && node.getAttribute && node.getAttribute('href')) return node;
      }
    }
    return ev && ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
  }

  function getCartFormFromPage() {
    return document.querySelector('form#cart') ||
      document.querySelector('#header-cart form[action*="cart"]') ||
      document.querySelector('#dropdnMinicartPopup form[action*="cart"]') ||
      document.querySelector('form[action*="/cart"]') ||
      document.querySelector('form[action*="cart"]');
  }

  function runStoreBCheckoutFromForm(form, submitter) {
    if (!form) form = getCartFormFromPage();
    if (!form) {
      form = document.createElement('form');
      form.setAttribute('action', (window.routes && window.routes.cart_url) || '/cart');
    }
    return handleSubmit({
      target: form,
      submitter: submitter || null,
      storeCheckoutIntent: true,
      preventDefault: function () {},
      stopPropagation: function () {}
    });
  }

  function suppressNativeCheckoutSurfaces() {
    document.querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons').forEach(function (el) {
      el.setAttribute('hidden', 'hidden');
      el.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('a[href]').forEach(function (link) {
      if (isNativeCheckoutUrl(link.getAttribute('href'))) {
        link.setAttribute('data-store-checkout-native-link', 'blocked');
        link.setAttribute('href', (window.routes && window.routes.cart_url) || '/cart');
      }
    });
  }

  function submitToBackend(payload, clearLoading, endpointPath) {
    var xhr = new XMLHttpRequest();
    var path = endpointPath === '/checkout/agent-cart' ? endpointPath : '/checkout';
    xhr.open('POST', backendUrl + path, true);
    xhr.timeout = CHECKOUT_TIMEOUT_MS;
    xhr.setRequestHeader('Content-Type', 'application/json');
    var requestId = 'co_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
    xhr.setRequestHeader('X-Store-Checkout-Request-Id', requestId);
    payload.request_id = requestId;
    function fail(message, errorData) {
      if (clearLoading) clearLoading();
      if (errorData && (errorData.code === 'required_options' || errorData.code === 'product_options_unavailable')) {
        showCartCheckoutError(message || errorData.error, errorData);
        return;
      }
      alert(message || 'Checkout unavailable. Please try again.');
    }
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      if (xhr.status === 200) {
        try {
          var res = JSON.parse(xhr.responseText);
          if (res.redirect_url) {
            window.location.href = res.redirect_url;
            return;
          }
        } catch (e) { }
        fail('Checkout error. Please try again.');
        return;
      }
      var msg = 'Checkout unavailable. Please try again.';
      try {
        var err = JSON.parse(xhr.responseText);
        if (err.error) msg = err.error;
        if (err.detail) msg = msg + '\n\n' + err.detail;
        fail(msg, err);
        return;
      } catch (e) { }
      fail(msg);
    };
    xhr.onerror = function () {
      fail('Checkout network error. Please check your connection and try again.');
    };
    xhr.ontimeout = function () {
      fail('Checkout took too long to respond. Please try again.');
    };
    xhr.send(JSON.stringify(payload));
  }

  function runAgentCartCheckout(link, url) {
    if (!link || link.getAttribute('data-store-checkout-processing') === 'true') return false;
    link.setAttribute('data-store-checkout-processing', 'true');
    setCheckoutLoading([link], true);
    var clearLoading = function () {
      link.removeAttribute('data-store-checkout-processing');
      setCheckoutLoading([link], false);
    };
    var payload = { cart_url: url };
    if (window.STORE_CHECKOUT_CUSTOMER_ID) payload.customer_id = String(window.STORE_CHECKOUT_CUSTOMER_ID);
    addPresentmentCurrency(payload);
    submitToBackend(payload, clearLoading, '/checkout/agent-cart');
    return false;
  }

  function validateDiscountFromCart(cart, code) {
    if (!code) return Promise.resolve(null);
    var subtotal = (cart && cart.total_price != null) ? Number(cart.total_price) / 100 : 0;
    var itemCount = 0;
    if (cart && cart.items && Array.isArray(cart.items)) {
      for (var i = 0; i < cart.items.length; i++) {
        itemCount += parseInt(cart.items[i].quantity, 10) || 0;
      }
    }
    return fetch(backendUrl + '/validate-discount', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        code: code,
        subtotal: subtotal,
        item_count: itemCount,
        items: buildCheckoutItemsFromCart(cart),
        customer_id: window.STORE_CHECKOUT_CUSTOMER_ID || null
      })
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    });
  }

  function applyDiscountResultToBlock(block, code, result, subtotal) {
    if (!block || !result || !result.data) return false;
    var d = result.data;
    var amountInput = block.querySelector('input[name="discount_amount"]');
    var titleInput = block.querySelector('input[name="discount_title"]');
    var ratioInput = block.querySelector('input[name="discount_ratio"]');
    var valueTypeInput = block.querySelector('input[name="discount_value_type"]');
    var codeInput = block.querySelector('.js-store-checkout-discount-code');
    var appliedEl = block.querySelector('.js-store-checkout-discount-applied');
    var appliedText = block.querySelector('.js-store-checkout-discount-applied-text');
    var errorEl = block.querySelector('.js-store-checkout-discount-error');
    if (!d.valid || d.amount == null || Number(d.amount) <= 0) return false;
    if (codeInput && code) codeInput.value = code;
    if (amountInput) amountInput.value = String(d.amount);
    if (titleInput) titleInput.value = d.title || code || 'Discount';
    if (valueTypeInput && d.value_type) {
      valueTypeInput.value = (d.value_type === 'percentage' || d.value_type === 'fixed_amount') ? d.value_type : '';
    } else if (valueTypeInput) {
      valueTypeInput.value = '';
    }
    var ratio = null;
    if (typeof d.ratio === 'number' && d.ratio > 0) {
      ratio = d.ratio;
    } else if (subtotal > 0) {
      var amtNum = typeof d.amount === 'number' ? d.amount : parseFloat(d.amount);
      if (!isNaN(amtNum) && amtNum > 0) ratio = amtNum / subtotal;
    }
    ratio = normalizeRatio(ratio);
    if (ratioInput && ratio != null && isFinite(ratio) && ratio > 0) {
      ratioInput.value = String(ratio);
    } else if (ratioInput) {
      ratioInput.value = '';
    }
    if (appliedText) {
      var activeCurrency = getActiveCurrencyCode('GBP') || 'GBP';
      var labelAmount = typeof d.amount === 'number' ? d.amount : parseFloat(d.amount);
      appliedText.innerHTML =
        escapeHtml((d.title || code || 'Discount') + ratioPercentLabel(ratio)) +
        ' (-' + formatDisplayAmountHtml(labelAmount || 0, activeCurrency) + ')';
    }
    if (appliedEl) appliedEl.classList.remove('hidden');
    if (appliedEl) appliedEl.setAttribute('data-native-cart-discount', 'false');
    var removeBtn = block.querySelector('.js-store-checkout-remove-discount');
    if (removeBtn) removeBtn.classList.remove('hidden');
    if (errorEl) { errorEl.classList.add('hidden'); errorEl.textContent = ''; }
    syncOrderSummary();
    return true;
  }

  function handleSubmit(ev) {
    var form = ev.target && ev.target.tagName === 'FORM' ? ev.target : (ev.target && ev.target.closest && ev.target.closest('form'));
    if (!form) return;
    var submitter = ev.submitter || (ev.target && ev.target.tagName === 'BUTTON' ? ev.target : null);
    var isCheckout = ev.storeCheckoutIntent === true || (
      submitter
      && submitter.getAttribute
      && (submitter.getAttribute('name') === 'checkout' || submitter.hasAttribute('data-store-checkout-cart'))
    );
    // If this is the discount code form, treat submit (e.g. Enter key) as clicking "Apply" instead of doing a full page submit.
    var discountBlock = form.querySelector && form.querySelector('.js-store-checkout-discount');
    if (discountBlock && !isCheckout) {
      var applyBtn = discountBlock.querySelector('.js-store-checkout-apply-discount');
      if (applyBtn) {
        ev.preventDefault();
        ev.stopPropagation();
        applyBtn.click();
        return false;
      }
    }
    var action = (form.getAttribute('action') || '') + (form.action || '');
    if (isNativeCheckoutUrl(action)) {
      form = getCartFormFromPage() || form;
      action = (form.getAttribute('action') || '') + (form.action || '');
      isCheckout = true;
    }
    if (!isCheckout) return;
    if (action.indexOf('cart') === -1) return;
    ev.preventDefault();
    ev.stopPropagation();
    clearCartCheckoutError();
    var buttons = getCheckoutButtons(form, submitter);
    setCheckoutLoading(buttons, true);
    var note = getNote();
    var discountAmount = getDiscountAmount(form);
    var discountTitle = getDiscountTitle(form);
    var discountRatio = getDiscountRatio(form);
    var discountValueType = getDiscountValueType(form);
    var discountCode = getDiscountCode(form) || getStoredDiscountCode();
    var customerId = window.STORE_CHECKOUT_CUSTOMER_ID;
    var clearLoading = function () { setCheckoutLoading(buttons, false); };
    fetch(getCartUrl(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart unavailable');
        return r.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) {
          clearLoading();
          alert('Your cart is empty.');
          return;
        }
        if ((!discountAmount || !discountTitle) && discountCode) {
          return validateDiscountFromCart(cart, discountCode).then(function (result) {
            var block = document.querySelector('.js-store-checkout-discount');
            var subtotal = (cart.total_price != null) ? Number(cart.total_price) / 100 : 0;
            if (!applyDiscountResultToBlock(block, discountCode, result, subtotal)) {
              clearLoading();
              alert((result && result.data && result.data.error) || 'Discount code is not valid');
              return;
            }
            discountAmount = getDiscountAmount(form);
            discountTitle = getDiscountTitle(form);
            discountRatio = getDiscountRatio(form);
            discountValueType = getDiscountValueType(form);
            clearStoredDiscountCode();
            var payloadValidated = buildPayload(cart, note, discountAmount, discountTitle, discountRatio, discountValueType, customerId, cart.email);
            submitToBackend(payloadValidated, clearLoading);
          });
        }
        var payload = buildPayload(cart, note, discountAmount, discountTitle, discountRatio, discountValueType, customerId, cart.email);
        submitToBackend(payload, clearLoading);
      })
      .catch(function () {
        clearLoading();
        alert('Could not load cart. Please try again.');
      });
    return false;
  }

  function init() {
    suppressNativeCheckoutSurfaces();
    var suppressTimer = null;
    var suppressObserver = new MutationObserver(function () {
      if (suppressTimer) clearTimeout(suppressTimer);
      suppressTimer = setTimeout(suppressNativeCheckoutSurfaces, 50);
    });
    suppressObserver.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('submit', function (ev) {
      if (!backendUrl) return;
      handleSubmit(ev);
    }, true);

    document.addEventListener('click', function (ev) {
      if (!backendUrl) return;
      var cartCheckoutBtn = ev.target && (ev.target.closest && ev.target.closest('[data-store-checkout-cart]'));
      if (cartCheckoutBtn) {
        if (cartCheckoutBtn.disabled || (cartCheckoutBtn.classList && cartCheckoutBtn.classList.contains('disabled'))) return;
        ev.preventDefault();
        ev.stopPropagation();
        var cartForm = cartCheckoutBtn.closest && (cartCheckoutBtn.closest('form') || document.getElementById(cartCheckoutBtn.getAttribute('form')));
        runStoreBCheckoutFromForm(cartForm, cartCheckoutBtn);
        return;
      }
      var checkoutLink = getEventAnchor(ev);
      var checkoutHref = checkoutLink && checkoutLink.getAttribute('href');
      if (checkoutLink && isAgentCartUrl(checkoutHref)) {
        ev.preventDefault();
        ev.stopPropagation();
        runAgentCartCheckout(checkoutLink, checkoutLink.href || checkoutHref);
        return;
      }
      if (checkoutLink && isNativeCheckoutUrl(checkoutHref)) {
        ev.preventDefault();
        ev.stopPropagation();
        runStoreBCheckoutFromForm(getCartFormFromPage(), null);
        return;
      }
      var btn = ev.target && (ev.target.closest && ev.target.closest('[data-store-checkout-buy-now]'));
      if (!btn) return;
      if (btn.disabled || (btn.classList && btn.classList.contains('disabled'))) return;
      var form = btn.closest && (btn.closest('form') || btn.closest('product-form'));
      form = form && (form.tagName === 'FORM' ? form : form.querySelector && form.querySelector('form'));
      if (!form) return;
      ev.preventDefault();
      ev.stopPropagation();
      clearCartCheckoutError();
      if (window.ProductOptions && !window.ProductOptions.validateAndReport(form)) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var customerId = window.STORE_CHECKOUT_CUSTOMER_ID;
      setCheckoutLoading([btn], true);
      var clearLoading = function () { setCheckoutLoading([btn], false); };
      var formData = new FormData(form);
      formData.set('quantity', formData.get('quantity') || '1');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok && result.data && result.data.description) {
            clearLoading();
            alert(result.data.description);
            return;
          }
          if (!result.ok) {
            clearLoading();
            alert('Could not add to cart. Please try again.');
            return;
          }
          return fetch(getCartUrl(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) {
              if (!r.ok) throw new Error('Cart unavailable');
              return r.json();
            });
        })
        .then(function (cart) {
          if (!cart || !cart.items || cart.items.length === 0) {
            clearLoading();
            alert('Your cart is empty.');
            return;
          }
          var note = getNote();
          var code = getDiscountCode(null) || getStoredDiscountCode();
          if (code) {
            return validateDiscountFromCart(cart, code).then(function (result) {
              var block = document.querySelector('.js-store-checkout-discount');
              var subtotal = (cart.total_price != null) ? Number(cart.total_price) / 100 : 0;
              if (applyDiscountResultToBlock(block, code, result, subtotal)) {
                clearStoredDiscountCode();
                var payloadWithDiscount = buildPayload(
                  cart,
                  note,
                  getDiscountAmount(null),
                  getDiscountTitle(null),
                  getDiscountRatio(null),
                  getDiscountValueType(null),
                  customerId,
                  cart.email
                );
                submitToBackend(payloadWithDiscount, clearLoading);
                return;
              }
              var payloadNoDiscount = buildPayload(cart, note, undefined, null, undefined, undefined, customerId, cart.email);
              submitToBackend(payloadNoDiscount, clearLoading);
            });
          }
          var payload = buildPayload(cart, note, undefined, null, undefined, undefined, customerId, cart.email);
          submitToBackend(payload, clearLoading);
        })
        .catch(function () {
          clearLoading();
          alert('Could not complete Buy it now. Please try again.');
        });
    }, true);

    document.addEventListener('click', function (ev) {
      var applyBtn = ev.target && (ev.target.closest && ev.target.closest('.js-store-checkout-apply-discount'));
      if (applyBtn) {
        ev.preventDefault();
        var block = applyBtn.closest('.js-store-checkout-discount');
        if (!block) return;
        var codeInput = block.querySelector('.js-store-checkout-discount-code');
        var amountInput = block.querySelector('input[name="discount_amount"]');
        var titleInput = block.querySelector('input[name="discount_title"]');
        var appliedEl = block.querySelector('.js-store-checkout-discount-applied');
        var appliedText = block.querySelector('.js-store-checkout-discount-applied-text');
        var errorEl = block.querySelector('.js-store-checkout-discount-error');
        var code = codeInput && codeInput.value ? codeInput.value.trim() : '';
        if (!code) return;
        applyBtn.disabled = true;
        if (errorEl) { errorEl.classList.add('hidden'); errorEl.textContent = ''; }
        fetch(getCartUrl(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) {
            if (!r.ok) throw new Error('Cart unavailable');
            return r.json();
          })
          .then(function (cart) {
            if (!cart) throw new Error('Cart unavailable');
            var subtotal = (cart.total_price != null) ? Number(cart.total_price) / 100 : 0;
            var cartCurrency = (cart.currency || '').toUpperCase();
            if (subtotal <= 0) {
              applyBtn.disabled = false;
              if (errorEl) { errorEl.textContent = 'Your cart is empty.'; errorEl.classList.remove('hidden'); }
              return;
            }
            var itemCount = 0;
            if (cart.items && Array.isArray(cart.items)) {
              for (var i = 0; i < cart.items.length; i++) {
                itemCount += parseInt(cart.items[i].quantity, 10) || 0;
              }
            }
            var payload = {
              code: code,
              subtotal: subtotal,
              item_count: itemCount,
              items: buildCheckoutItemsFromCart(cart),
              customer_id: window.STORE_CHECKOUT_CUSTOMER_ID || null
            };
            return fetch(backendUrl + '/validate-discount', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload)
            }).then(function (r) {
              return r.json().then(function (data) { return { ok: r.ok, data: data }; });
            }).then(function (result) {
              // Nested inside cart handler so `subtotal` and `cartCurrency` are in scope
              applyBtn.disabled = false;
              if (!result || !result.data) return;
              var d = result.data;
              if (d.valid && d.amount != null && Number(d.amount) > 0) {
                // Always store shop-currency amount in hidden input (used by /checkout payload)
                if (amountInput) amountInput.value = String(d.amount);
                if (titleInput) titleInput.value = d.title || 'Discount';
                var valueTypeInput = block.querySelector('input[name="discount_value_type"]');
                if (valueTypeInput && d.value_type) {
                  valueTypeInput.value = (d.value_type === 'percentage' || d.value_type === 'fixed_amount') ? d.value_type : '';
                } else if (valueTypeInput) {
                  valueTypeInput.value = '';
                }
                var ratio = null;
                if (typeof d.ratio === 'number' && d.ratio > 0) {
                  ratio = d.ratio;
                } else if (subtotal > 0) {
                  var amtNum = typeof d.amount === 'number' ? d.amount : parseFloat(d.amount);
                  if (!isNaN(amtNum) && amtNum > 0) {
                    ratio = amtNum / subtotal;
                  }
                }
                ratio = normalizeRatio(ratio);
                var ratioInput = block.querySelector('input[name="discount_ratio"]');
                if (ratioInput && ratio != null && isFinite(ratio) && ratio > 0) {
                  ratioInput.value = String(ratio);
                } else if (ratioInput) {
                  ratioInput.value = '';
                }

                // Build the tag label from the visible rounded subtotal so display math matches
                // the summary and checkout discount rule.
                var appliedLabel = d.title || 'Discount';
                var pctText = ratioPercentLabel(ratio);

                var activeCurrency = getActiveCurrencyCode(cartCurrency || 'GBP');
                var discountForTag = null;
                var subtotalValueEl = document.querySelector('#main-cart-items .js-store-checkout-subtotal-value') ||
                  document.querySelector('.cart-page-column .js-store-checkout-subtotal-value');
                var visibleSubtotalForTag = readConvertedValue(subtotalValueEl);
                if (isFinite(visibleSubtotalForTag) && visibleSubtotalForTag > 0 && ratio != null && isFinite(ratio) && ratio > 0) {
                  discountForTag = Number((visibleSubtotalForTag * ratio).toFixed(2));
                }
                if ((discountForTag == null || !isFinite(discountForTag) || discountForTag <= 0) && ratio != null && isFinite(ratio) && ratio > 0) {
                  var subtotalRowEl = document.querySelector('#main-cart-items .js-store-checkout-subtotal-row') ||
                    document.querySelector('.cart-page-column .js-store-checkout-subtotal-row');
                  if (subtotalRowEl) {
                    var subtotalCentsRaw = parseInt(subtotalRowEl.getAttribute('data-subtotal-cents'), 10);
                    var subtotalCurrencyRaw = (subtotalRowEl.getAttribute('data-currency') || '').trim();
                    if (!isNaN(subtotalCentsRaw) && subtotalCentsRaw > 0) {
                      discountForTag = Number(((subtotalCentsRaw / 100) * ratio).toFixed(2));
                      if (subtotalCurrencyRaw) activeCurrency = subtotalCurrencyRaw;
                    }
                  }
                }
                if ((discountForTag == null || !isFinite(discountForTag) || discountForTag <= 0) && typeof d.amount === 'number' && d.amount > 0) {
                  discountForTag = Number(d.amount);
                }
                if (discountForTag != null && isFinite(discountForTag) && discountForTag > 0) {
                  var amountHtml = formatDisplayAmountHtml(discountForTag, activeCurrency || 'GBP');
                  if (appliedText) {
                    appliedText.innerHTML =
                      escapeHtml(appliedLabel + pctText) +
                      ' (-' + amountHtml + ')';
                  }
                  if (appliedEl) appliedEl.classList.remove('hidden');
                }
                if (errorEl) { errorEl.classList.add('hidden'); errorEl.textContent = ''; }
                clearStoredDiscountCode();
                syncOrderSummary();
              } else {
                if (errorEl) { errorEl.textContent = d.error || 'Discount code is not valid'; errorEl.classList.remove('hidden'); }
              }
            });
          })
          .catch(function (err) {
            applyBtn.disabled = false;
            if (errorEl) {
              errorEl.textContent = (err && err.message === 'Cart unavailable') ? 'Could not load cart. Please try again.' : 'Could not validate discount. Please try again.';
              errorEl.classList.remove('hidden');
            }
          });
        return;
      }
      var removeBtn = ev.target && (ev.target.closest && ev.target.closest('.js-store-checkout-remove-discount'));
      if (removeBtn) {
        ev.preventDefault();
        var block = removeBtn.closest('.js-store-checkout-discount');
        if (!block) return;
        var amountInput = block.querySelector('input[name="discount_amount"]');
        var titleInput = block.querySelector('input[name="discount_title"]');
        var ratioInput = block.querySelector('input[name="discount_ratio"]');
        var codeInput = block.querySelector('.js-store-checkout-discount-code');
        var appliedEl = block.querySelector('.js-store-checkout-discount-applied');
        var errorEl = block.querySelector('.js-store-checkout-discount-error');
        if (amountInput) amountInput.value = '';
        if (titleInput) titleInput.value = '';
        if (ratioInput) ratioInput.value = '';
        var valueTypeInput = block.querySelector('input[name="discount_value_type"]');
        if (valueTypeInput) valueTypeInput.value = '';
        if (codeInput) codeInput.value = '';
        clearStoredDiscountCode();
        if (appliedEl) appliedEl.classList.add('hidden');
        if (errorEl) { errorEl.classList.add('hidden'); errorEl.textContent = ''; }
        syncOrderSummary();
      }
    }, true);

    // Clear checkout button loading when user returns to the page (e.g. back from Store B).
    // Defer so we run after bfcache restore; run on every pageshow and when tab becomes visible.
    function clearLoadingWhenShown() {
      requestAnimationFrame(function () {
        clearAllCheckoutLoading();
      });
    }
    window.addEventListener('pageshow', function (e) {
      clearLoadingWhenShown();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') clearLoadingWhenShown();
    });
    window.addEventListener('focus', function () {
      clearLoadingWhenShown();
    });
  }

  function observeSubtotalForSync() {
    var subtotalBlock = document.querySelector('#main-cart-items .js-contents-subtotal') || document.querySelector('.cart-page-column .js-contents-subtotal');
    if (!subtotalBlock) return;
    subtotalSyncNode = subtotalBlock;
    syncOrderSummary();
    try {
      subtotalSyncObserver = new MutationObserver(function () {
        syncOrderSummary();
      });
      subtotalSyncObserver.observe(subtotalBlock, { childList: true, subtree: true });
    } catch (e) { }
  }

  function initAll() {
    var locationCode = findDiscountCodeFromLocation();
    if (locationCode) {
      storeDiscountCode(locationCode);
      setDiscountCodeValue(locationCode);
    } else {
      setDiscountCodeValue(getStoredDiscountCode());
    }
    init();
    observeSubtotalForSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
